const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "类型",
        prop: "energyType",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: '光伏',
            value: '0'
          },
          {
            label: '风电',
            value: '1'
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 0) {
            return "光伏";
          } else if (Number(value) === 1) {
            return "风电";
          }
          return "";
        }
      },
      {
        label: "装机容量(kW)",
        prop: "installCapacity",
      },
      {
        label: "运行时长(h)",
        prop: "runTime",
      },
      {
        label: "排放因子(tCO₂/MWh)",
        prop: "emissionFactor",
      },
      {
        label: "CO₂减排量(t)",
        prop: "co2Reduction",
      },
      {
        label: "备注",
        prop: "energyRemark",
      }
    ]
  };
};

export default tableOption;
